<div class="flex flex-col-reverse full-width bg-surface -mt-2">
  <div class="mb-3">
    <soft-step-header [steps]="steps" [currentIndex]="0" #stepper></soft-step-header>
  </div>
  <soft-default-header
    [overline]="'Schritt 1 von 4'"
    [title]="stepper.current()?.header | translate"
    [subtitle]="stepper.current()?.subHeader | translate"
  ></soft-default-header>
</div>

<soft-lagerplatz-suche
  class="mt-4"
  (lagerplatzChange)="onLagerplatzSelected($event)"
></soft-lagerplatz-suche>
@if (loading$ | async) {
  <soft-blocking-loading-spinner
    class="top-0 right-0"
  ></soft-blocking-loading-spinner>
}
